import {
  Box,
  Button,
  Chip,
  IconButton,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { LIFECYCLE_STATUSES } from "config/immunizationConstants";

export const btnStyle = {
  width: "max-content",
  padding: "0.5rem 2rem",
  color: "#194AF5",
  bgcolor: "#E6EBFF",
  boxShadow: "none",
  borderRadius: "8px",
  ":hover": { bgcolor: "#E6EBFF", color: "#194AF5", boxShadow: "none" },
};

export const primaryBtnStyle = {
  ...btnStyle,
  bgcolor: "#194AF5",
  color: "white",
  ":hover": {},
};

export const StatusChip = ({ status }) => (
  <Chip
    size="small"
    label={status === "RETIRED" ? "Retired" : "Active"}
    sx={{
      bgcolor: status === "RETIRED" ? "#FDECEC" : "#EFFEED",
      color: status === "RETIRED" ? "#C62828" : "#399F08",
      fontWeight: 600,
      borderRadius: "25px",
    }}
  />
);

export const RowActions = ({ record, onEdit, onLifecycle }) => {
  const retired = record?.lifecycleStatus === "RETIRED";
  const locked = Boolean(record?.isSystemDefined) && !retired;

  return (
    <Box sx={{ display: "flex", gap: "0.25rem" }}>
      <Tooltip title="Edit">
        <IconButton onClick={() => onEdit(record)}>
          <EditIcon fontSize="small" color="primary" />
        </IconButton>
      </Tooltip>

      {locked ?
        <Tooltip title="Shipped by DRCFO — referenced by seeded definitions and cannot be retired">
          <span>
            <IconButton disabled>
              <LockOutlinedIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      : <Tooltip title={retired ? "Reactivate" : "Retire"}>
          <IconButton onClick={() => onLifecycle(record)}>
            {retired ?
              <UnarchiveOutlinedIcon fontSize="small" color="success" />
            : <ArchiveOutlinedIcon fontSize="small" color="warning" />}
          </IconButton>
        </Tooltip>
      }
    </Box>
  );
};

const MasterToolbar = ({
  addLabel,
  onAdd,
  lifecycleStatus,
  onLifecycleStatusChange,
  busy,
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "0.75rem",
      padding: "1rem 0",
      flexWrap: "wrap",
    }}
  >
    <TextField
      select
      size="small"
      label="Status"
      value={lifecycleStatus}
      onChange={(event) => onLifecycleStatusChange(event.target.value)}
      sx={{ minWidth: 160 }}
    >
      <MenuItem value="">All</MenuItem>
      {LIFECYCLE_STATUSES.map((status) => (
        <MenuItem key={status} value={status}>
          {status === "RETIRED" ? "Retired" : "Active"}
        </MenuItem>
      ))}
    </TextField>

    <Button
      sx={primaryBtnStyle}
      variant="contained"
      disabled={busy}
      onClick={onAdd}
    >
      {addLabel}
    </Button>
  </Box>
);

export default MasterToolbar;
